/**
 * @desc 财务画像-基础信息-研发及产权信息
 */
import style from './researchAndEquity.scss';
import React, { PureComponent } from 'react';
import GroupBox from '../../../common/groupBox/GroupBox';
import { Row, Col, Spin } from 'antd';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import AntdTable from '../../common/AntdTable';
import NoData from '../../../common/noData/NoData';
import { isNotEmpty, isEmpty } from '../../../../utils/util';
import { numberFixed } from '../../../../utils/formatter';
import { commonRequest, commonLineOptin } from '../../common/commons';
import {
    reaserchResult, reaserchNum,
    trademark, software, production, reaserchInput
} from '../../../../services/financialPicture/baseInfo';

export default class ResearchAndEquity extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            equityData: {},
            personInput: {},
            costInput: {},
            loading: false,
            inputLoading: false
        };
    }

    componentDidMount() {
        this.researchNumProt();
        this.researchInputrot();
    }

    // 研发人员及费用投入
    researchInputrot = () => {
        this.setState({
            inputLoading: true
        });
        reaserchInput(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                inputLoading: false,
                costInput: this.reaserchBarOption(
                    '资本化的研发费用', '费用化的研发费用',
                    data.capdevExpe, data.devExpe, data.enddate, true),
                personInput: this.reaserchBarOption(
                    '研发人员数量', '研发人员占比', data.rdStaffNum,
                    data.rdStaffOccur, data.enddate)
            });
        }).finally(() => {
            this.setState({
                inputLoading: false
            });
        });
    };

    // 研发人员及费用投入, 返回图表数据
    reaserchBarOption = (name, devName, capdevExpe, devExpe, category, barStack) => {
        if (capdevExpe.every(d => d === 0 || isEmpty(d)) && devExpe.every(d => d === 0 || isEmpty(d))) {
            return {};
        }
        let color = ['#2365C4', '#F99248'], 
            costInput = [{name: name, data: capdevExpe}, { name: devName, data: devExpe }],
            personInput = {barData: [{ name: name, data: capdevExpe }], lineData: [{ yAxisIndex: 1, name: devName, data: devExpe }]},
            rightY = barStack ? false : { // 是否显示右侧y轴
                min: 0,
                axisLine: {
                    show: true
                },
                axisLabel: {
                    show: true,
                    formatter: val => {
                        return numberFixed(val) + '%';
                    }
                }
            };
        return {
            barData: barStack ? costInput :  personInput.barData,
            lineData: barStack ? '' : personInput.lineData,
            category: category,
            color: color,
            barGap: 0,
            barStack: barStack ? 'count' : false,
            yAxis: [{
                color: '#88A3B4',
                nameTextStyle: {
                    color: '#88A3B4'
                }
            }, rightY],
            grid: {
                top: 40,
                bottom: '3%',
                right: barStack ? '3%' : '12%'
            },
            tooltip: { // 研发人员-占比显示百分比
                formatter: val => {
                    return `<div>
                            <p>${name}: ${val[0].value}</p>
                            <p>${devName}: ${barStack ? val[1].value === undefined ? '--' : val[1].value : val[1].value === undefined ? '--' : val[1].value + '%'}</p>
                        </div>`;
                }
    
            }
        };
    }

    // 研发结果
    researchResult = () => {
        return [
            {
                title: '序号',
                dataIndex: 'index',
                width: 80
            },
            {
                title: '名称',
                dataIndex: 'title'
            },
            {
                title: '专利号',
                dataIndex: 'application_code'
            },
            {
                title: '专利类型',
                dataIndex: 'patent_type'
            },
            {
                title: '权利人',
                dataIndex: 'applicant'
            },
            {
                title: '公开时间',
                width: 140,
                dataIndex: 'publidate'
            }
        ];
    };

    // 专利数量
    researchNumProt = () => {
        this.setState({
            loading: true
        });
        reaserchNum(commonRequest()).then(data => {
            data = data || {};
            let color = ['#534FCF'],
                grid = { top: 15, left: '3%', right: '2%' };
            this.setState({
                loading: false,
                equityData: commonLineOptin({ lineData: data.count, category: data.year, color: color, grid: grid, same: false, tip: true })
            });
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    };

    // 商标表头
    PTColumns = () => {
        return [
            {
                title: '序号',
                dataIndex: 'index'
            },
            {
                title: '商标',
                dataIndex: 'brand_image',
                render: text => <img src={'data:image/png;base64,' + text} className={style.trademark} />
            },
            {
                title: '名称',
                dataIndex: 'brand_name'
            },
            {
                title: '注册号',
                dataIndex: 'application_no'
            },
            {
                title: '类别',
                dataIndex: 'class_brand'
            }
        ];
    };

    // 软件著作
    softwareColumns = (work) => {
        return [
            {
                title: '序号',
                dataIndex: 'index'
            },
            {
                title: '名称',
                dataIndex: work ? 'soft_full_name' : 'production_name'
            },
            {
                title: '登记号',
                dataIndex: 'regnum'
            },
            {
                title: work ? '版本' : '创作完成时间',
                dataIndex: work ? 'version_num' : 'creation_completion_date'
            },
            {
                title: '登记时间',
                dataIndex: 'regdate'
            }
        ];
    };

    render() {
        const { loading, inputLoading, equityData, costInput, personInput } = this.state;
        return (
            <div>
                <GroupBox id="research-put-into" title="研发投入">
                    <div className={style.reaserchIput}>
                        <Row>
                            <Col span={12}>
                                <div className="sub-title">研发人员投入</div>
                                <div className={style.research}>
                                    {inputLoading ? <Spin /> :
                                        isNotEmpty(personInput) ?
                                            <BBDLineBar option={personInput} /> :
                                            <NoData />
                                    }
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="sub-title">研发费用投入</div>
                                <div className={style.research}>
                                    {inputLoading ? <Spin /> :
                                        isNotEmpty(costInput) ?
                                            <BBDLineBar option={costInput} /> :
                                            <NoData />
                                    }
                                </div>
                            </Col>
                        </Row>
                    </div>
                </GroupBox>
                <AntdTable
                    idName={'research-result'}
                    title={'研发结果'}
                    list={true}
                    columns={this.researchResult()}
                    requestApi={reaserchResult}
                />
                <div>
                    <Row>
                        <Col span={24}>
                            <p className="sub-title">专利数量</p>
                            <div className={style.equityNum}>
                                {loading ? <Spin title="数据加载中..." /> :
                                    isNotEmpty(equityData) ?
                                        <BBDLineBar option={equityData} /> :
                                        <NoData />
                                }
                            </div>
                        </Col>
                    </Row>
                </div>
                <AntdTable
                    idName={'trademark'}
                    title={'商标'}
                    list={true}
                    requestApi={trademark}
                    columns={this.PTColumns()}
                />
                <AntdTable
                    idName={'software'}
                    title={'软件著作'}
                    list={true}
                    requestApi={software}
                    columns={this.softwareColumns(true)}
                />
                <AntdTable
                    idName={'production'}
                    title={'作品著作'}
                    list={true}
                    requestApi={production}
                    columns={this.softwareColumns()}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/researchAndEquity/ResearchAndEquity.jsx